import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const layout = document.getElementById(process.env.REACT_APP_ROOT_ID).getAttribute('layout') || 'Main';
const pluginId = document.getElementById(process.env.REACT_APP_ROOT_ID).getAttribute('data-plugin');

ReactDOM.render(
  <App
    layout={layout}
    pluginId={pluginId}
  />, document.getElementById(process.env.REACT_APP_ROOT_ID)
);
